
module.exports = { 
      attributes: {},
    
      body: "Care in which the intent is primarily quality of life for a patient with an active, progressive disease with little or no prospect of cure.\n",
    
      meta: {"resourcePath":"/home/vsts/work/1/s/src/tenants/amh/content/categoryDescription/default/palliative-care.md"},
     }